export default __webpack_public_path__ + "static/media/mapa_logo.749cbd22.svg";